import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Rounter, Routes, Route, Switch, Link, Outlet } from 'react-router-dom';

function Footer() {
    return (
        <div className="footer">
            <div className="container">Copyright © 2022 by Maru</div>
        </div>
    );
}

export default Footer